import { render } from "./VideosAndImages.vue?vue&type=template&id=6f675f52&scoped=true"
import script from "./VideosAndImages.vue?vue&type=script&lang=js"
export * from "./VideosAndImages.vue?vue&type=script&lang=js"

import "./VideosAndImages.vue?vue&type=style&index=0&id=6f675f52&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f675f52"]])

export default __exports__